export default "__VITE_ASSET__q6dVU$v9__"